<div 
  class="tab-bar"
  [ngStyle]="tabBarStyles | theme"
  >
  <ng-container *ngFor="let tab of tabs; index as i">
    <ng-container *ngIf="buttonType === 'pill'; else tabButtonTemplate">
      <app-pill-tab-button
        [label]="tab.label"
        [isSelected]="selectedTabIndex === i"
        (clickEvent)="onTabClick(i)"
        class="pill-gap"
      ></app-pill-tab-button>
    </ng-container>
    <ng-template #tabButtonTemplate>
      <app-tab-button
        [label]="tab.label"
        [isSelected]="selectedTabIndex === i"
        (clickEvent)="onTabClick(i)"
      ></app-tab-button>
    </ng-template>
  </ng-container>

  <div 
    *ngIf="buttonType === 'tab'"
    class="tab-bar__underline"
    [ngClass]="{
      'tab-bar__underline--circle': underlineStyle === 'circle',
      'tab-bar__underline--animate': shouldAnimate
    }"
    [style.transform]="underlineTransform"
    [style.width]="underlineWidth"
    [style.height]="underlineStyle === 'circle' ? circleRadius : 'var(--tab-highlight-line-border-width)'"
  ></div>
</div>
